import { confirmable, createConfirmation } from 'react-confirm';
import './styles.scss';
import {useClickAway} from 'react-use';
import { useRef } from 'react';
const Dialog = confirmable(({show, proceed, confirmation, options, actionText, actionColor}) => {
  console.log(options)
  const ref = useRef()
  useClickAway(ref, () => {
    proceed(false)
  })
  return (
    <div className='DialogWrapper'>
      <div className='Dialog' ref={ref}>
      {/* <div onHide={() => proceed(false)} show={show}> */}
        {confirmation}
        <div className='buttons'>
          <button className='button' onClick={() => proceed(false)}>Cancel</button>
          <button
            className='button'
            onClick={() => proceed(true)}
            style={{ backgroundColor: actionColor || '#28a443', color: actionColor? '#fff': null}}
          >
            {actionText || 'OK'}
          </button>
        </div>
      </div>
    </div>
  )
  })

// confirmable HOC pass props `show`, `dismiss`, `cancel` and `proceed` to your component.


// create confirm function
const confirm = createConfirmation(Dialog, 0);
export default confirm
